export default "__VITE_ASSET__Ckxdd7Gk__"